export default {
	back_home: 'ホームに戻る',
	buy_now: '今すぐ購入',
	data_disk: 'データディスク',
	empty: '商品はありません',
	invoice_not_found: '請求書が見つからないか、リンクが無効です',
	package: 'プラン',
	per_month: '/月',
	server_desc: '専用物理ハードウェア、高性能、大帯域、追加IP可能',
	server_title: '専用物理サーバー',
	system_disk: 'システムディスク',
	vps_desc: '高性能・高可用性・高コストパフォーマンス',
	vps_title: 'VPSクラウドサーバー',
}
